<div class="main-container" data-cy="forms-builder-confirm-container">

  <div class="message-header" data-cy="forms-builder-confirm-message-container">
    <h5 data-cy="forms-builder-confirm-message">{{ message }}</h5>
  </div>

  <div class="action-container" data-cy="forms-builder-confirm-action-container">
    <button mat-raised-button color="primary" class="action-button" (click)="confirm()" data-cy="forms-builder-confirm-button">Confirm</button>
    <button mat-raised-button color="warn" class="action-button" (click)="cancel()" data-cy="forms-builder-confirm-cancel-button">Cancel</button>

  </div>

</div>
